/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconDocNewspaper8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDocNewspaper8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M.998 1v4.667c0 .466 0 .7.091.878.08.157.208.284.365.364.178.091.411.091.878.091h4a1 1 0 0 0 1-1V2.333H5.999V1H.998Zm5 2h.667v3A.333.333 0 0 1 6 6V3ZM2 6.333A.333.333 0 0 1 1.667 6l-.002-4.333h3.667V6c0 .117.02.23.057.333h-3.39Zm.332-2.666h2.333l.002 2H2.332v-2Zm0-1.334V3h2.333v-.667H2.332Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDocNewspaper12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDocNewspaper12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M1.496 1.5v7c0 .7 0 1.05.137 1.317.12.236.311.427.546.547.268.136.618.136 1.318.136h6a1.5 1.5 0 0 0 1.5-1.5V3.5h-2v-2h-7.5Zm7.5 3h1V9a.5.5 0 0 1-1 0V4.5ZM3 9.5a.5.5 0 0 1-.5-.5l-.002-6.5h5.5V9c0 .175.03.344.085.5H3Zm.498-4h3.5l.002 3H3.497v-3Zm0-2v1h3.5v-1h-3.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDocNewspaper16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDocNewspaper16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m1.996 2 .001 9.333c0 .933 0 1.4.182 1.756.16.314.414.57.728.729.357.181.823.181 1.757.181h8a2 2 0 0 0 2-2V4.666h-2.667V2h-10Zm10.001 4h1.333v6a.667.667 0 0 1-1.333 0V6ZM4 12.666A.667.667 0 0 1 3.333 12L3.33 3.333h7.334v8.666c0 .234.04.459.114.667H4Zm.664-5.333H9.33l.003 4h-4.67v-4Zm0-2.667V6H9.33V4.666H4.664Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDocNewspaper24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDocNewspaper24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m2.994 3 .002 14c0 1.4 0 2.1.272 2.634a2.5 2.5 0 0 0 1.093 1.093C4.895 21 5.595 21 6.996 21h12a3 3 0 0 0 3-3V7h-4V3H2.994Zm15.002 6h2v9a1 1 0 1 1-2 0V9ZM6 19a1 1 0 0 1-1-1L4.996 5h11v13c0 .35.06.687.17 1H6Zm.996-8h7L14 17H6.996v-6Zm0-4v2h7V7h-7Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconDocNewspaper = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDocNewspaper(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconDocNewspaper8 {...iconProps} />;
        case '12':
            return <IconDocNewspaper12 {...iconProps} />;
        case '16':
            return <IconDocNewspaper16 {...iconProps} />;
        case '24':
            return <IconDocNewspaper24 {...iconProps} />;
        default:
            return <IconDocNewspaper24 {...iconProps} />;
    }
});
